import React from 'react'

import { useParams } from 'react-router'

import { Loader } from '@percept/mui'

import { DefaultLayoutComponent } from './layout'

import { SeriesViewManager } from 'components/Series'

import { useReportSeries, useReportSeriesReports } from '@percept/hooks'

import { SeriesParams } from '@percept/types'


export const SeriesScreen = (): JSX.Element => {
  const { series_id } = useParams<SeriesParams>()
  const [series] = useReportSeries({ series_id })
  useReportSeriesReports({ series_id })
  return (
    <DefaultLayoutComponent>
      { series.data ? (
        <SeriesViewManager key={series_id} series_id={series_id} />
      ) : <Loader preset='fullscreen' /> }
    </DefaultLayoutComponent>
  )
}

export default SeriesScreen
